import { WarningOutlined } from '@ant-design/icons';
import { useAuth } from 'hooks';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export const MimicBanner = () => {
  const { t } = useTranslation();
  const { user } = useAuth();

  if (!user?.isMimic) return null;

  return (
    <Banner>
      <WarningOutlined />
      {t('components.mimic_banner.impersonating', { email: user.email })}
    </Banner>
  );
};

const Banner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 12px 20px;
  background: ${(props) => props.theme.color.text.danger};
  color: ${(props) => props.theme.color.white};
  font-size: 18px;
  font-weight: 600;
`;
